module.exports = __webpack_public_path__ + "static/img/oppo2.3c35c63.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/oppo/oppo2.png
// module id = E4En
// module chunks = 0